import { DataSource, Label, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutEdiStatusOrderTab extends Layout {
    labelHazmatCommodity: Label;
    panelHazmat: Panel;
    panelOrderTab: Panel;
    sourceEdistatus: DataSource;
    textboxBlnum: Textbox;
    textboxCarrierTrailer: Textbox;
    textboxCcProNbr: Textbox;
    textboxCommodity: Textbox;
    textboxCommodityId: Textbox;
    textboxCurrCases: Textbox;
    textboxCurrWeight: Textbox;
    textboxDeliverySignature: Textbox;
    textboxFrtGrpProNbr: Textbox;
    textboxManifestId: Textbox;
    textboxMovementId: Textbox;
    textboxProNbr: Textbox;
    textboxRefno: Textbox;
    textboxScac: Textbox;
    textboxSeal: Textbox;
    textboxServiceStandard: Textbox;
    textboxShipmentId: Textbox;
    textboxTractorId: Textbox;
    textboxTrailerId: Textbox;
    textboxTrailerType: Textbox;
    textboxTripLease: Textbox;
}
